<div data-padding-backward></div>
@for (item of items(); track item.uid) {
  <div
    [attr.data-sid]="item.$index"
    [style.position]="item.invisible ? 'fixed' : null"
    [style.left]="item.invisible ? '-99999px' : null"
  >
    <ng-template
      [ngTemplateOutlet]="template()"
      [ngTemplateOutletContext]="{
        $implicit: item.data,
        index: item.$index,
        odd: item.$index % 2,
        even: !(item.$index % 2)
      }"
    ></ng-template>
  </div>
}
<div data-padding-forward></div>
